import { createStore } from 'vuex'

export default createStore({
  state: {
    isAuthenticated: !!localStorage.getItem('token'),
    token: '',
    isLoading: false,
    jobId: '',
    user: null
  },
  getters: {
    currentUserName: (state) => {
      return state.user?.first_name || 'User'
    },
    isAdmin: (state) => {
      return state.user?.is_staff === true
    }
  },
  mutations: {
    initializeStore(state) {
      if (localStorage.getItem('token')) {
        state.token = localStorage.getItem('token')
        state.isAuthenticated = true

        if (localStorage.getItem('jobId')) {
          state.jobId = localStorage.getItem('jobId')
        }

        if (localStorage.getItem('user')) {
          state.user = JSON.parse(
            localStorage.getItem('user')
          )
        }

      } else {

        state.token = ''
        state.isAuthenticated = false
        state.jobId = ''
        state.user = null
      }
    },
    setIsLoading(state, status) {
      state.isLoading = status
    },
    setToken(state, token) {
      state.token = token
      state.isAuthenticated = true

      localStorage.setItem('token', token)
    },
    removeToken(state) {
      state.token = ''
      state.isAuthenticated = false

      localStorage.removeItem('token')
    },
    setUser(state, user) {
      state.user = user

      localStorage.setItem(
        'user',
        JSON.stringify(user)
      )
    },
    clearUser(state) {
      state.user = null

      localStorage.removeItem('user')
    },
    setJobId(state, jobId) {
      state.jobId = jobId

      localStorage.setItem('jobId', jobId)
    },
    clearJobId(state) {
      state.jobId = ''

      localStorage.removeItem('jobId')
    }
  },
  actions: {
    setUser({ commit }, user) {
      commit('setUser', user)
    },
    logout({ commit }) {
      commit('removeToken')
      commit('clearUser')
      commit('clearJobId')
    }
  }
})